/**
 * Namespace connect rejections from the game server. Transport failures
 * (`timeout`, `websocket error`) must not be treated as an auth failure —
 * refreshing on those rotates the single-use refresh token and shows up in
 * Faro next to real `Unauthorized` connect loops.
 */
export function isAuthSocketError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const record = error as {
    message?: unknown;
    data?: { message?: unknown; status?: unknown };
  };
  const messages = [record.message, record.data?.message].filter(
    (value): value is string => typeof value === 'string',
  );
  if (messages.some(message => /unauthori[sz]ed/i.test(message))) return true;
  return record.data?.status === 401;
}
